<script setup>
import { computed, watch, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';

const props = defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
  selectedTab: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['tabChange']);

const { t } = useI18n();

const activeTab = ref(props.selectedTab);

watch(
  () => props.selectedTab,
  (value, oldValue) => {
    if (value !== oldValue) {
      activeTab.value = props.selectedTab;
    }
  }
);

const tabBarTabs = computed(() => {
  return props.tabs.map(tab => ({
    label: tab.name,
    count: tab.showBadge ? tab.count : null,
  }));
});

const onTabChange = selectedTab => {
  const index = props.tabs.findIndex(tab => tab.name === selectedTab.label);
  activeTab.value = index;
  emit('tabChange', props.tabs[index].key);
};
</script>

<template>
  <div
    class="flex items-center justify-between mt-8 mb-6 bg-muted/30 p-1 rounded-2xl border border-border/50"
  >
    <TabBar
      :tabs="tabBarTabs"
      :initial-active-tab="activeTab"
      class="!mt-0 !mb-0"
      @tab-changed="onTabChange"
    />

    <div class="lg:flex hidden items-center px-4">
      <div
        class="flex items-center gap-2 text-xs font-bold text-muted-foreground/60 uppercase tracking-widest"
      >
        <span class="i-lucide-arrow-up-down size-3" />
        <span>{{ t('SEARCH.SORT_BY.RELEVANCE') }}</span>
      </div>
    </div>
  </div>
</template>
